import { getPageContent } from './states';

export const services = {
  getPageContent,
};
